import classNames from 'classnames';

// TODO: naming
export type IconSize = 'extra-extra-small' | 'extra-small' | 'large' | 'medium-small' | 'middle' | 'small';

// TODO: resolve colors
type IconType = 'dark-default' | 'default' | 'error' | 'info' | 'primary' | 'secondary' | 'success';

type P = {
  backgroundColor?: 'white';
  shape?: 'circle';
  size?: IconSize;
  spanClassName?: string;
  type?: IconType;
} & SvgWrapperProperties;

type SvgWrapperProperties = React.SVGProps<SVGSVGElement>;

const withAntIconWrapper = (SvgComponent: React.FunctionComponent<SvgWrapperProperties>) =>
  function ({ backgroundColor, rotate, shape, size, spanClassName, type, ...props }: P) {
    return (
      <span
        className={classNames(spanClassName, 'appicon', 'anticon', {
          'appicon--background--white': backgroundColor === 'white',
          'appicon--circle': shape === 'circle',
          'appicon--dark-default': type === 'dark-default',
          'appicon--default': type === 'default',
          'appicon--error': type === 'error',
          'appicon--extra-extra-small': size === 'extra-extra-small',
          'appicon--extra-small': size === 'extra-small',
          'appicon--info': type === 'info',
          'appicon--large': size === 'large',
          'appicon--medium-small': size === 'medium-small',
          'appicon--middle': size === 'middle',
          'appicon--primary': type === 'primary',
          'appicon--secondary': type === 'secondary',
          'appicon--small': size === 'small',
          'appicon--success': type === 'success',
        })}
      >
        <SvgComponent style={{ transform: rotate ? `rotate(${rotate}deg)` : undefined }} {...props} />
      </span>
    );
  };

export default withAntIconWrapper;
